import React, { useEffect } from "react";
import { useColorScheme } from "@mui/material/styles";
import useAuth from "../../context/UserContext";
import { usePreferences } from "../../hooks/usePreferences";
import UserPreferences from "../../constants/userPreferences";

export const ThemePreferenceLoader: React.FC = () => {
  usePreferences({ preferenceToFetch: UserPreferences.Mode });
  const { user } = useAuth();
  const { setMode } = useColorScheme();
  useEffect(() => {
    setMode(user.userPreferences.mode);
  }, [setMode, user.userPreferences.mode]);

  return null;
};
